export const STAFF_NAME_PARTS = ["firstName", "lastName"] as const;

export const STAFF_NAME_LABELS = {
  firstName: "users.firstNameIn",
  lastName: "users.lastNameIn",
} as const;
